<central-login-header [platform]="currentPlatform"></central-login-header>
<div class="content">
    <h3 class="form-title">{{ 'central-login.select.account' | translate }}</h3>

    <div class="alert alert-danger" *ngIf="error">
        {{ 'central-login.select.account.error.no.user' | translate }}
    </div>

    <div class="platform-user u-cursor--pointer" (click)="selectUser(platformUser)" *ngFor="let platformUser of platformUsers">
        {{ platformUser.platformUserFirstName + ' ' + platformUser.platformUserLastName}}
    </div>
</div>
<central-login-footer></central-login-footer>
<central-login-background-slider [platform]="currentPlatform" ></central-login-background-slider>
<form id="goToPlatformForm" action="" method="post">
    <input type="hidden" name="central_access_token" value="">
    <input type="hidden" name="central_refresh_token" value="">
    <input type="hidden" name="refresh_token" value="">
    <input type="hidden" name="access_token" value="">
    <input type="hidden" name="expires_in" value="">
    <input type="hidden" name="force_token_refresh" value="false">
</form>
